<div
  class="group flex flex-col bg-white p-6 md:p-8 rounded-2xl items-center cursor-pointer border border-gray-200
         hover:-translate-y-1.5 hover:border-transparent
         focus:outline-none focus:ring-4 focus:ring-[var(--primary)] transition-all duration-300"
  tabindex="0"
  role="button"
  [attr.aria-label]="'Category: ' + name"
>
  <div class="w-20 h-20 rounded-2xl bg-[var(--primary)]/10 text-[var(--primary)] flex items-center justify-center mb-4 group-hover:bg-[var(--primary)] group-hover:text-white transition-all duration-300">
    <fa-icon [icon]="icon" size="2xl"></fa-icon>
  </div>
  <h3 class="text-lg font-bold text-gray-900 text-center group-hover:text-[var(--primary)] transition-colors duration-300">{{ name }}</h3>
  <span class="text-xs font-semibold text-gray-400 mt-2 flex items-center gap-1 group-hover:text-[var(--primary)] transition-colors duration-300">
    Explore Collection &rarr;
  </span>
</div>
